import React, { useState, useEffect } from 'react';
import api from '../services/api';
import WhatsAppSettings from '../components/WhatsAppSettings';
import TenantSettings from '../components/TenantSettings';

const SettingsPage = () => {
  const [activeTab, setActiveTab] = useState('whatsapp'); // Default or selectable

  // Change Password state
  const [oldPassword, setOldPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [passError, setPassError] = useState('');
  const [passSuccess, setPassSuccess] = useState('');

  // Financial Years state
  const [fyears, setFyears] = useState([]);
  const [Fid, setFid] = useState('');
  const [StartYear, setStartYear] = useState('');
  const [EndYear, setEndYear] = useState('');
  const [fyError, setFyError] = useState('');
  const [fySuccess, setFySuccess] = useState('');


  useEffect(() => {
    fetchFyears();
  }, []);

  const fetchFyears = async () => {
    try {
      const res = await api.get('/masters/financial-years');
      setFyears(res.data);
    } catch (err) {
      console.error('Failed to load financial years', err);
    }
  };

  const handlePasswordChange = async (e) => {
    e.preventDefault();
    setPassError(''); setPassSuccess('');

    if (newPassword !== confirmPassword) {
      setPassError('New passwords do not match!');
      return;
    }

    try {
      await api.post('/auth/change-password', { oldPassword, newPassword });
      setPassSuccess('Password updated successfully!');
      setOldPassword('');
      setNewPassword('');
      setConfirmPassword('');
    } catch (err) {
      setPassError(err.response?.data?.message || 'Failed to update password');
    }
  };

  const handleAddFyear = async (e) => {
    e.preventDefault();
    setFyError(''); setFySuccess('');

    try {
      await api.post('/masters/financial-years', {
        Fid: parseInt(Fid),
        StartYear,
        EndYear
      });
      setFySuccess('Financial year added successfully!');
      setFid(''); setStartYear(''); setEndYear('');
      fetchFyears();
    } catch (err) {
      setFyError('Failed to add financial year');
    }
  };

  return (
    <div className="container-fluid py-4">
      <div className="d-flex justify-content-between align-items-center mb-4 pb-2 border-bottom">
        <div>
          <h3 className="fw-bold mb-1 text-primary">
            <i className="bi bi-gear me-2"></i>Settings & Configuration (सेटींग)
          </h3>
          <p className="text-muted mb-0">System configuration, WhatsApp gateway setup, multi-tenant DBs, and security settings</p>
        </div>
      </div>

      {/* TAB NAVIGATION */}
      <ul className="nav nav-pills mb-4 gap-2">
        <li className="nav-item">
          <button
            className={`nav-link rounded-pill px-4 fw-semibold ${activeTab === 'whatsapp' ? 'active bg-success shadow-sm text-white' : 'bg-white text-secondary border'}`}
            onClick={() => setActiveTab('whatsapp')}
          >
            <i className="bi bi-whatsapp me-2"></i>
            व्हॉट्सॲप सेटींग (WhatsApp Settings)
          </button>
        </li>
        <li className="nav-item">
          <button
            className={`nav-link rounded-pill px-4 fw-semibold ${activeTab === 'tenant' ? 'active bg-dark shadow-sm text-white' : 'bg-white text-secondary border'}`}
            onClick={() => setActiveTab('tenant')}
          >
            <i className="bi bi-diagram-3 me-2"></i>
            डोमेन डेटाबेस सेटींग (Domain DB Settings)
          </button>
        </li>
        <li className="nav-item">
          <button
            className={`nav-link rounded-pill px-4 fw-semibold ${activeTab === 'general' ? 'active bg-primary shadow-sm text-white' : 'bg-white text-secondary border'}`}
            onClick={() => setActiveTab('general')}
          >
            <i className="bi bi-shield-lock me-2"></i>
            पासवर्ड व आर्थिक वर्ष (Password & FY)
          </button>
        </li>
      </ul>

      {activeTab === 'whatsapp' ? (
        <WhatsAppSettings />
      ) : activeTab === 'tenant' ? (
        <TenantSettings />
      ) : (
        <div className="row g-4">

          {/* CHANGE PASSWORD */}
          <div className="col-12 col-md-6">

          <div className="card border-0 shadow-sm h-100">
            <div className="card-header bg-primary text-white fw-bold">
              <i className="bi bi-key me-2"></i>Change User Password
            </div>
            <div className="card-body">
              {passError && <div className="alert alert-danger py-2">{passError}</div>}
              {passSuccess && <div className="alert alert-success py-2">{passSuccess}</div>}

              <form onSubmit={handlePasswordChange}>
                <div className="mb-3">
                  <label className="form-label fw-semibold">Current Password</label>
                  <input
                    type="password"
                    className="form-control"
                    placeholder="Enter current password"
                    value={oldPassword}
                    onChange={(e) => setOldPassword(e.target.value)}
                    required
                  />
                </div>

                <div className="mb-3">
                  <label className="form-label fw-semibold">New Password</label>
                  <input
                    type="password"
                    className="form-control"
                    placeholder="Enter new password"
                    value={newPassword}
                    onChange={(e) => setNewPassword(e.target.value)}
                    required
                  />
                </div>

                <div className="mb-4">
                  <label className="form-label fw-semibold">Confirm New Password</label>
                  <input
                    type="password"
                    className="form-control"
                    placeholder="Re-enter new password"
                    value={confirmPassword}
                    onChange={(e) => setConfirmPassword(e.target.value)}
                    required
                  />
                </div>

                <button type="submit" className="btn btn-primary w-100 fw-bold shadow-sm">
                  <i className="bi bi-check-circle me-1"></i> Update Password
                </button>
              </form>
            </div>
          </div>
        </div>

        {/* FINANCIAL YEAR MANAGEMENT */}
        <div className="col-12 col-md-6">
          <div className="card border-0 shadow-sm h-100">
            <div className="card-header bg-primary text-white fw-bold">
              <i className="bi bi-calendar3 me-2"></i>Financial Year Management (आर्थिक वर्ष)
            </div>
            <div className="card-body">
              {fyError && <div className="alert alert-danger py-2">{fyError}</div>}
              {fySuccess && <div className="alert alert-success py-2">{fySuccess}</div>}

              <form onSubmit={handleAddFyear} className="mb-4">
                <div className="row g-2 mb-3">
                  <div className="col-4">
                    <label className="form-label fw-semibold">FY ID</label>
                    <input
                      type="number"
                      className="form-control"
                      placeholder="e.g. 5"
                      value={Fid}
                      onChange={(e) => setFid(e.target.value)}
                      required
                    />
                  </div>
                  <div className="col-4">
                    <label className="form-label fw-semibold">Start Date</label>
                    <input
                      type="date"
                      className="form-control"
                      value={StartYear}
                      onChange={(e) => setStartYear(e.target.value)}
                      required
                    />
                  </div>
                  <div className="col-4">
                    <label className="form-label fw-semibold">End Date</label>
                    <input
                      type="date"
                      className="form-control"
                      value={EndYear}
                      onChange={(e) => setEndYear(e.target.value)}
                      required
                    />
                  </div>
                </div>

                <button type="submit" className="btn btn-outline-primary w-100 fw-bold">
                  <i className="bi bi-plus-circle me-1"></i> Add Financial Year
                </button>
              </form>

              <h6 className="fw-bold text-dark border-bottom pb-2">Active Financial Years List</h6>
              <div className="table-responsive" style={{ maxHeight: '200px' }}>
                <table className="table table-sm table-hover align-middle mb-0">
                  <thead className="table-light">
                    <tr>
                      <th>ID</th>
                      <th>Start Date</th>
                      <th>End Date</th>
                    </tr>
                  </thead>
                  <tbody>
                    {fyears.map(fy => (
                      <tr key={fy.Fid}>
                        <td className="fw-bold">FY #{fy.Fid}</td>
                        <td>{fy.StartYear}</td>
                        <td>{fy.EndYear}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    )}
  </div>
  );
};


export default SettingsPage;
